<template>
  <v-card v-if="hasSubAccounts">
    <v-card-text class="pb-0">
      <v-select outlined
        @input="load"
        :label="$t('settings.user.selectBox')"
        v-model="owner"
        item-text="label"
        item-value="id"
        :items="accounts">
        <template v-slot:prepend-inner>
          <v-icon color="primary">mdi-account-cog</v-icon>
        </template>
        <template v-slot:append-outer>
          <cp-help i18n="userAccSelect" />
        </template>
      </v-select>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import events from 'Store/events'

export default {
  name: 'settings-user-select',
  computed: {
    ...mapGetters({
      subAccounts: 'settings/subAccounts',
      userName: 'sipua/cidName',
      userExten: 'sipua/exten',
      userID: 'settings/userID',
      ownerID: 'settings/ownerID'
    }),
    hasSubAccounts: function () {
      return this.subAccounts?.length > 0
    },
    owner: {
      get: function () {
        return this.ownerID
      },
      set: function (id) {
        this.setOwnerID(id)
      }
    },
    accounts: function () {
      const fmt = (name, ext, id) => {
        return { label: `${name} <${ext}>`, id: id }
      }

      const accs = [fmt(this.userName, this.userExten, this.userID)]
      for (const acc of this.subAccounts) {
        accs.push(fmt(acc.name, acc.username, acc.user_id))
      }
      return accs
    }
  },
  methods: {
    ...mapActions({
      setOwnerID: 'settings/setOwnerID',
      getSettings: 'settings/loadAccSettings'
    }),
    load: function () {
      events.mask()
      this.getSettings(this.owner)
        .catch(err => {
          this.dbg(err)
        }).finally(() => {
          events.unmask()
        })
    }
  }
}
</script>

<style scoped>
</style>
